<terra-welcome-layout>
  <section class="welcome-text">
    Welcome back
  </section>

  <section class="welcome-sub-text">
    Covercy works with investors, businesses and individuals to get funds overseas safely, quickly and for the best rates around.
  </section>

  <section class="form-content">
    
    <ng-container *ngIf="{logoData: referrerLogo$ | async} as referrer">
      <img class="referrer-logo" *ngIf="referrer?.logoData?.showLogo" [src]="referrer?.logoData?.logoUrl"/>
    </ng-container>
    
    <form [formGroup]="usernameFormGroup" (ngSubmit)="forgotPassword()" class="form terra-error-style" (keydown.enter)="$event.preventDefault()">
      <h1>Forgot your password?</h1>
      <ng-container *ngIf="!usernameFormGroupSubmitted">
        <p class="goto-register" >
          Don’t have an account yet?
          <a [routerLink]="routingService.signupUrlBySubdomain" queryParamsHandling="preserve" routerLinkActive="active">Sign Up</a>
        </p>

        
        <p class="sub-description">
          Enter the email address you registered with and we'll send you a reset password link.
        </p>
        
        <mat-form-field appearance="outline" class="input-width">
          <input matInput placeholder="Email" formControlName="username" maxlength="250" />
          <mat-error *ngIf="usernameFormGroup.get('username').hasError('email')"> Please enter a valid email address </mat-error>
          <mat-error *ngIf="usernameFormGroup.get('username').hasError('required')"> Email is required </mat-error>
        </mat-form-field>

        
        <ngx-recaptcha2 #recaptcha formControlName="recaptcha" class="recaptcha"
        [siteKey]="appSettingsService.recaptchaPublicKey">
      </ngx-recaptcha2>
      <mat-error *ngIf="submit && usernameFormGroup.get('recaptcha').hasError('required')" class="recaptcha-error">
        Please verify you're not a robot
      </mat-error>
      
      <mat-error *ngIf="hasError">An error has occurred, please try again or contact support</mat-error>
      
      <div class="input-width">
        <button type="submit" mat-flat-button class="tall-button" color="primary" [disabled]="isLoading">
          Send Me a Reset Link
        </button>
      </div>
      
      <div class="authorized-uk"><mat-icon class="notranslate">verified_user</mat-icon> Authorised by the UK FCA</div>
      
      <a
      class="light link back-to-login-link"
      [routerLink]="routingService.loginUrlBySubdomain"
      queryParamsHandling="preserve"
      routerLinkActive="active"
      >Back to login</a
      >
    </ng-container>

      <div class="after-send-text" *ngIf="usernameFormGroupSubmitted">
        <p>
          If there's a covercy account associated with <strong>{{ ForgotPasswordEmail }} </strong>
          , we'll send over a reset password link right away.
        </p>
        <p>
          If you don't see the email in your inbox within the next 5 minutes, please check your spam folder or contact
          <a href="mailto:support@covercy.com">support&#64;covercy.com</a>.
        </p>
      </div>
    </form>

    <div class="data-safe">
      <img src="/assets/images/icons/data-safe.png" />
    </div>
  </section>
</terra-welcome-layout>
